



















































import { Vue, Component, Prop } from 'vue-property-decorator';

import { formatDistance } from '~/utils/units.js';

@Component
export default class DestinationRouteCard extends Vue {
  @Prop(Object) sport: Types.SportItem;
  @Prop(String) linkToMap: '';

  /* Computed method to populate difficulties and their total counter */
  get difficultyCircles () {
    if (this.sport?.routes?.length) {
      const total: {[key: string]: { number: number, class: string }} = {
        0: { number: 0, class: 'border-zinc-200' },
        1: { number: 0, class: 'border-green-default' },
        2: { number: 0, class: 'border-info-default' },
        3: { number: 0, class: 'border-red-default' },
        4: { number: 0, class: 'border-black' },
      };

      const keys: Array<string> = Object.keys(total);
      this.sport.routes.forEach((route: Types.Route) => {
        keys.forEach((key: string) => {
          if (key === route.difficulty?.toString()) {
            total[key].number++;
          }
        });
      });
      return total;
    }
    return [];
  }

  /* Computed method to return total distance of routes no matter the difficulty */
  get totalDistance () {
    if (this.sport?.routes?.length) {
      let total = 0;

      this.sport.routes.forEach((route: Types.Route) => {
        if (route.distance) total += route.distance;
      });

      return formatDistance(total);
    }
    return '-';
  }
}
